import { Form, Modal } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { useImportCodeFrame } from '../../../api/Questions';
import CodeFrameSelect from '../../../components/CodeFrameSelect';

const StyledModal = styled(Modal)`
  .ant-modal-body {
    overflow-x: scroll;
    max-height: calc(100vh - 250px);
  }
`;

const StyledFormItem = styled(Form.Item)`
  padding: 0 8px;
`;

function ImportCodeFrameModal({ visible, setVisible, questionId, surveyId, onStart }) {
  const [form] = Form.useForm();
  const codeFrame = Form.useWatch('codeFrame', form);

  const { mutate: importCodeFrame, isLoading: importCodeFrameLoading } = useImportCodeFrame();

  const handleImportCodeFrame = (codeFrameId) => {
    importCodeFrame(
      { questionId, codeFrameId, surveyId },
      {
        onSuccess: () => {
          onStart();
          setVisible(false);
        },
      },
    );
  };

  const onFinish = async (formValues) => {
    handleImportCodeFrame(formValues.codeFrame.codeFrameId);
    setVisible(false);
  };

  return (
    <StyledModal
      title="Import code frame"
      open={visible}
      onOk={() => {
        form
          .validateFields()
          .then(onFinish)
          .catch(() => {});
      }}
      okText="Import"
      okButtonProps={{ disabled: !codeFrame?.codeFrameId }}
      onCancel={() => setVisible(false)}
      confirmLoading={importCodeFrameLoading}
      closable={false}
      maskClosable={false}
      destroyOnClose
    >
      <Form form={form} layout="vertical" preserve={false} colon={false}>
        <StyledFormItem
          name="codeFrame"
          rules={[
            {
              validator: (_, val) => {
                if (!val?.surveyId || !val?.codeFrameId) {
                  return Promise.reject(new Error('Please select both a survey and a question'));
                }
                return Promise.resolve();
              },
            },
          ]}
          initialValue={{ surveyId, codeFrameId: null }}
        >
          <CodeFrameSelect label="Select the survey and question to import code frame from" />
        </StyledFormItem>
      </Form>
    </StyledModal>
  );
}

ImportCodeFrameModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  questionId: PropTypes.number.isRequired,
  surveyId: PropTypes.number.isRequired,
  onStart: PropTypes.func.isRequired,
};

export default ImportCodeFrameModal;
